<div class="gw-flex gw-flex-col gw-gap-medium gw-max-w-[720px]">
  <section
    class="gw-rounded-xl gw-border-base gw-bg-background-elevation-3 gw-p-medium"
  >
    <h2 class="gw-m-0 gw-text-base gw-font-semibold gw-text-text-primary">
      {{ 'features.security.password.title' | translate }}
    </h2>
    <p class="gw-m-0 gw-mt-2x-small gw-text-sm gw-text-text-secondary">
      {{ 'features.security.password.description' | translate }}
    </p>

    <form
      class="gw-mt-medium gw-flex gw-flex-col gw-gap-small"
      [formGroup]="passwordForm"
      (ngSubmit)="submitPasswordChange()"
    >
      <gatewee-input-v2
        type="password"
        id="security-current-password"
        [form]="passwordForm"
        controlName="oldPassword"
        label="features.security.password.currentLabel"
        [autocomplete]="true"
      ></gatewee-input-v2>

      <gatewee-input-v2
        type="password"
        id="security-new-password"
        [form]="passwordForm"
        controlName="newPassword"
        label="features.security.password.newLabel"
        [autocomplete]="true"
      ></gatewee-input-v2>

      <gatewee-input-v2
        type="password"
        id="security-confirm-password"
        [form]="passwordForm"
        controlName="confirmPassword"
        label="features.security.password.confirmLabel"
        [autocomplete]="true"
      ></gatewee-input-v2>

      <p
        *ngIf="passwordsMismatch"
        class="gw-m-0 gw-text-sm gw-text-status-negative"
        role="alert"
      >
        {{ 'features.security.password.mismatch' | translate }}
      </p>

      <div class="gw-mt-small">
        <gatewee-button
          type="submit"
          iconName="@tui.lock"
          [title]="'features.security.password.submit' | translate"
          [loading]="passwordSubmitting"
          [disabled]="
            passwordSubmitting || passwordForm.invalid || passwordsMismatch
          "
        ></gatewee-button>
      </div>
    </form>
  </section>

  <section
    class="gw-rounded-xl gw-border-base gw-bg-background-elevation-3 gw-p-medium"
    *ngIf="false"
  >
    <div
      class="gw-flex gw-flex-wrap gw-items-start gw-justify-between gw-gap-small"
    >
      <div class="gw-min-w-0">
        <h2 class="gw-m-0 gw-text-base gw-font-semibold gw-text-text-primary">
          {{ 'features.security.twoFactor.title' | translate }}
        </h2>
        <p class="gw-m-0 gw-mt-2x-small gw-text-sm gw-text-text-secondary">
          {{ 'features.security.twoFactor.description' | translate }}
        </p>
      </div>

      <span
        *ngIf="!twoFactorLoading"
        class="gw-inline-flex gw-items-center gw-rounded-full gw-px-small gw-py-2x-small gw-text-xs gw-font-semibold gw-border gw-border-border-normal"
        [class.gw-text-status-positive]="twoFactorEnabled"
        [class.gw-text-text-secondary]="!twoFactorEnabled"
      >
        {{
          (twoFactorEnabled
            ? 'features.security.twoFactor.statusEnabled'
            : 'features.security.twoFactor.statusDisabled'
          ) | translate
        }}
      </span>
    </div>

    <div *ngIf="twoFactorLoading" class="gw-mt-medium gw-text-text-secondary">
      {{ 'features.security.twoFactor.loading' | translate }}
    </div>

    <ng-container *ngIf="!twoFactorLoading">
      <div
        *ngIf="!twoFactorEnabled && !setupPreview"
        class="gw-mt-medium gw-flex gw-flex-wrap gw-gap-small"
      >
        <gatewee-button
          iconName="@tui.shield-check"
          [title]="'features.security.twoFactor.enableAction' | translate"
          [loading]="twoFactorActionLoading"
          [disabled]="twoFactorActionLoading"
          (clicked)="startTwoFactorSetup()"
        ></gatewee-button>
      </div>

      <div
        *ngIf="!twoFactorEnabled && setupPreview"
        class="gw-mt-medium gw-flex gw-flex-col gw-gap-medium"
      >
        <p class="gw-m-0 gw-text-sm gw-text-text-secondary">
          {{ 'features.security.twoFactor.setupHint' | translate }}
        </p>

        <img
          *ngIf="setupPreview?.qrCode"
          [src]="setupPreview?.qrCode"
          alt="{{ 'features.security.twoFactor.qrAlt' | translate }}"
          class="gw-mx-auto gw-h-[200px] gw-w-[200px] gw-rounded-lg gw-border gw-border-border-normal gw-bg-white gw-p-small"
        />

        <div
          *ngIf="setupPreview?.secret"
          class="gw-rounded-lg gw-bg-background-elevation-1 gw-p-small"
        >
          <span class="gw-text-xs gw-font-medium gw-text-text-secondary">
            {{ 'features.security.twoFactor.secretLabel' | translate }}
          </span>
          <p
            class="gw-m-0 gw-mt-2x-small gw-break-all gw-font-mono gw-text-sm gw-text-text-primary"
          >
            {{ setupPreview?.secret }}
          </p>
        </div>

        <div class="gw-flex gw-flex-col gw-gap-small gw-max-w-[360px]">
          <label class="gw-form-label gw-m-0">
            {{ 'features.security.twoFactor.confirmCodeLabel' | translate }}
          </label>
          <tui-textfield
            tuiTextfieldSize="m"
            class="gw-w-full"
            [style.-webkit-text-security]="'disc'"
          >
            <input
              tuiInputPin
              maxlength="6"
              placeholder="••••••"
              inputmode="numeric"
              autocomplete="one-time-code"
              [formControl]="setupCodeControl"
              [disabled]="twoFactorActionLoading"
            />
          </tui-textfield>
        </div>

        <div class="gw-flex gw-flex-wrap gw-gap-small">
          <gatewee-button
            variant="outline"
            iconName="@tui.x"
            [title]="'common.actions.cancel' | translate"
            [disabled]="twoFactorActionLoading"
            (clicked)="cancelTwoFactorSetup()"
          ></gatewee-button>
          <gatewee-button
            iconName="@tui.check"
            [title]="'features.security.twoFactor.confirmEnable' | translate"
            [loading]="twoFactorActionLoading"
            [disabled]="twoFactorActionLoading || !isSetupCodeValid"
            (clicked)="confirmTwoFactorSetup()"
          ></gatewee-button>
        </div>
      </div>

      <div *ngIf="twoFactorEnabled" class="gw-mt-medium">
        <gatewee-button
          variant="outline"
          iconName="@phi.shield-slash"
          [title]="'features.security.twoFactor.disableAction' | translate"
          [loading]="twoFactorActionLoading"
          [disabled]="twoFactorActionLoading"
          (clicked)="disableTwoFactor()"
        ></gatewee-button>
      </div>
    </ng-container>
  </section>
</div>
